import { HttpMethod } from '@previo/core'
import { APIPaths } from '~/http/APIPaths'
import Http from '~/http/Http'
import type { PropertyListResponse } from '~/components/switch-property/http/types'

class PropertySuggestAPI extends Http {
  suggestProperties = (search: null | string): Promise<PropertyListResponse> => {
    return this.callAuthAPI<null, PropertyListResponse>(HttpMethod.GET, {
      path: APIPaths.PROPERTY_PROPERTIES_SUGGEST,
      query: {
        search: search,
      },
    })
  }
}

export const usePropertySuggestAPI = (): PropertySuggestAPI => {
  return new PropertySuggestAPI()
}
